import { atom } from 'jotai';
import localforage from 'localforage';
import { localForageEffect } from './effects/localForageEffect';
import { CustomerCanRefuelingData } from '../../components/VehiclesSettings/types';

export const getSelectedCustomersFromIndexedDb = async (): Promise<number[]> => {
  const selectedCustomers = await localforage.getItem<number[]>('selectedCustomers');
  if (!selectedCustomers) {
    return [];
  }
  return selectedCustomers;
};

export interface ICustomer {
  id: number;
  name: string;
  shortName: string;
  label: string | null;
  salesChannel: {
    id: number;
    shortName: string;
  };
  default_currency: number;
  default_tax_percentage: number;
  serverId?: number;
  branchId?: number;
}

export const customersAtom = atom<ICustomer[]>([]);

/** Initial value is []; hydrated from IndexedDB in JotaiEffects. */
export const selectedCustomersAtom = atom<number[]>([]);
export const selectedCustomersLocalForageEffectAtom = localForageEffect(
  selectedCustomersAtom,
  'selectedCustomers'
);

export const selectedTempCustomersAtom = atom<number[]>([]);

export const selectedCustomersWithDataAtom = atom<ICustomer[]>((get) => {
  const ids = get(selectedCustomersAtom);
  const customersList = get(customersAtom);
  const data: ICustomer[] = [];
  ids.forEach((customerId: number) => {
    const customer = customersList.find((item: ICustomer) => item.id === customerId);
    if (customer) {
      data.push(customer);
    }
  });
  return data;
});

export const filteredCustomersAtom = atom<ICustomer[]>([]);

/**
 * Helper to filter customers to only those that have vehicles.
 * Use with useAtomValue(customersAtom) and useAtomValue(vehiclesAtom) in components.
 */
export function getCustomersWithVehicles(
  customersList: ICustomer[],
  vehiclesList: Record<number, { customerId?: number }>
): ICustomer[] {
  const customerIdsWithVehicles = new Set<number>();
  Object.values(vehiclesList).forEach((vehicle) => {
    if (vehicle?.customerId) {
      customerIdsWithVehicles.add(vehicle.customerId);
    }
  });
  return customersList.filter((customer) => customerIdsWithVehicles.has(customer.id));
}

export const searchCustomersAtom = atom<string>('');

/** Alias for migration from Recoil */
export const selectedCustomersWithDataSelector = selectedCustomersWithDataAtom;

export const customerCanRefuelingAtom = atom<CustomerCanRefuelingData>({});
